export class SengiColors {
    /* aqua colors*/
    static sng_iceblue= '#DDF7F6';
    static sng_aqua = '#BEE9E8';
    static sng_lagune = '#9ED4D3';

    /* karibik colors */
    static sng_ocean = '#77CBE1';
    static sng_karibik = '#62B6CB';
    static sng_atlantik = '#449DB3';

    /* deepblue colors */
    static sng_marine = '#2E6789';
    static sng_deepblue = '#1B4965';
    static sng_nightblue = '#0E344B';

    static sng_standardblue = 'rgb(28, 33, 78)';

    /* secondary colors */
    static sng_flieder = '#E4CCFF';
    static sng_lavendel = '#B8B8FF';
    static sng_veilchen = '#9381FF';


    /* highlight colors */
    static sng_mint = '#80FFDB';
    static sng_tropical = '#45D4AB';

    /* status colors */
    static sng_error = '#C9184A';
    static sng_warning = '#F9C74F';
    static sng_success = '#9DB65B';
    static sng_info = '#17A2B8';
    static sng_disabled = '#6C757D';

    /* grey colors */
    static sng_white = '#FCFDFD';
    static sng_pearl = '#EFF4F4';
    static sng_silver = '#D2DADA';

    static sng_anthracite = '#384248';
    static sng_charcoal = '#242D33';
    static sng_black = '#12191D';

    static data: Record<string, string> = {
        "#DDF7F6": SengiColors.sng_iceblue,
        "#BEE9E8": SengiColors.sng_aqua,
        "#9ED4D3": SengiColors.sng_lagune,
        "#77CBE1": SengiColors.sng_ocean,
        "#62B6CB": SengiColors.sng_karibik,
        "#449DB3": SengiColors.sng_atlantik,
        "#2E6789": SengiColors.sng_marine,
        "#1B4965": SengiColors.sng_deepblue,
        "#0E344B": SengiColors.sng_nightblue,
        "#E4CCFF": SengiColors.sng_flieder,
        "#B8B8FF": SengiColors.sng_lavendel,
        "#9381FF": SengiColors.sng_veilchen,
        "#80FFDB": SengiColors.sng_mint,
        "#45D4AB": SengiColors.sng_tropical,
        "#C9184A": SengiColors.sng_error,
        "#F9C74F": SengiColors.sng_warning,
        "#9DB65B": SengiColors.sng_success,
        "#17A2B8": SengiColors.sng_info,
        "#6C757D": SengiColors.sng_disabled,
        "#FCFDFD": SengiColors.sng_white,
        "#EFF4F4": SengiColors.sng_pearl,
        "#D2DADA": SengiColors.sng_silver,
        "#384248": SengiColors.sng_anthracite,
        "#242D33": SengiColors.sng_charcoal,
        "#12191D": SengiColors.sng_black,
        "rgb(28, 33, 78)": SengiColors.sng_standardblue
    }

    static listAll(): Array<string> {
        return Object.keys(this.data);
    }

    static get(elem: string): string | null {
        if (elem in Object.keys(this.data)) {
            return this.data[elem];
        }
        return null;
    }
};